import { DOC_TYPES } from "src/data/legalDocument";
import LegalDocumentPage from "src/components/legal/LegalDocumentPage";
import { useT } from "src/i18n";

export default function Tietosuoja() {
    const t = useT();
    return (
        <LegalDocumentPage
            docType={DOC_TYPES.PRIVACY}
            path="/tietosuoja"
            title={t("legal.tietosuoja.pageTitle")}
            description={t("legal.tietosuoja.pageDescription")}
            heading={t("legal.tietosuoja.heading")}
            loadFailedMessage={t("legal.tietosuoja.loadFailed")}
        />
    );
}
